import { render, staticRenderFns } from "./Roteirization.vue?vue&type=template&id=0ddd40f2"
import script from "./Roteirization.vue?vue&type=script&lang=js"
export * from "./Roteirization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports